import styled from 'styled-components'

export const Box = styled.div`
  background: #fdfdfd;
  border: 1px solid var(--neutral-black-9-color);
  border-radius: 8px;
  padding: 8px;
  margin-right: 8px;
  margin-bottom: 8px;
`
export const BoxTitle = styled.div`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  opacity: 90%;
  color: #365b7e;
`
export const BoxAmount = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0em;
  color: var(--main-color-text);
`
